
export const location = () => {
    const geolocation = navigator.geolocation; 
    return new Promise((resolve, reject) => {
        if (!geolocation) {
            reject({error: "Geolocation not available"});
        }
        
        geolocation.getCurrentPosition((position) => {
            resolve(position);
        }, () => {
            reject ({error: "something went wrong"});
        });
    });
}

export const fetchLocation = () =>{
    return async dispatch => {
        dispatch({
           type: "LOC_FETCHING"
        });
        try {
            let loc = await location();
            dispatch({
                type: "LOC_FULFILLED",
                payload: {lat: loc.coords.latitude, lng: loc.coords.longitude}
            });
        } catch(error){
            dispatch({
                type: "LOC_REJECTED",
                payload: error
            });
        } 
    }
}